import './eqc-3d.scss'
import $ from 'jquery'
import '../../common/js/lazyload/lazyload'
import 'resize-end'
import * as THREEJS from 'three'
import SmoothScroll from 'smooth-scrollbar'
// import * as Zlib from 'zlibjs'
import anime from 'animejs'
import 'intersection-observer'
import { TweenLite, Power2 } from 'gsap'
import * as dat from 'dat.gui'
import isMobile from 'ismobilejs'
import { Howl } from 'howler'
import '../../../static/static-assets/eqc/three/fullTilt.js'
const RGBELoader = require('../../../static/static-assets/eqc/three/RGBELoader')(THREEJS)
const HDRCubeTextureLoader = require('../../../static/static-assets/eqc/three/HDRCubeTextureLoader')(THREEJS, RGBELoader)
const GLTFLoader = require('../../../static/static-assets/eqc/three/GLTFLoader')(THREEJS)
const PMREMGenerator = require('../../../static/static-assets/eqc/three/PMREMGenerator')(THREEJS)
const PMREMCubeUVPacker = require('../../../static/static-assets/eqc/three/PMREMCubeUVPacker')(THREEJS)
const CopyShader = require('../../../static/static-assets/eqc/three/CopyShader')(THREEJS)
let THREE = THREEJS
// window.Zlib = Zlib
Object.assign(THREE, { CopyShader: CopyShader })
const Pass = require('../../../static/static-assets/eqc/three/Pass')(THREE)
Object.assign(THREE, { Pass: Pass })
const ShaderPass = require('../../../static/static-assets/eqc/three/ShaderPass')(THREE)
Object.assign(THREE, { ShaderPass: ShaderPass })
const { MaskPass, ClearMaskPass } = require('../../../static/static-assets/eqc/three/ShaderPass')(THREE)
Object.assign(THREE, { MaskPass: MaskPass, ClearMaskPass: ClearMaskPass })
const RenderPass = require('../../../static/static-assets/eqc/three/RenderPass')(THREE)
Object.assign(THREE, { RenderPass: RenderPass })
const EffectComposer = require('../../../static/static-assets/eqc/three/EffectComposer')(THREE)
Object.assign(THREE, { EffectComposer: EffectComposer })
const ConvolutionShader = require('../../../static/static-assets/eqc/three/ConvolutionShader')(THREE)
Object.assign(THREE, { ConvolutionShader: ConvolutionShader })
const LuminosityHighPassShader = require('../../../static/static-assets/eqc/three/LuminosityHighPassShader')(THREE)
Object.assign(THREE, { LuminosityHighPassShader: LuminosityHighPassShader })
const BloomPass = require('../../../static/static-assets/eqc/three/UnrealBloomPass')(THREE)
Object.assign(THREE, { BloomPass: BloomPass })
const Sky = require('../../../static/static-assets/eqc/three/Sky')(THREE)
Object.assign(THREE, { Sky: Sky })
// const FBXLoader = require('../../../static/eqc/three/FBXLoader')(THREE)
// Object.assign(THREE, { FBXLoader: FBXLoader })
const CarPaintMaterial = require('../../../static/static-assets/eqc/three/CarPaintMaterial')(THREE)
Object.assign(THREE, { CarPaintMaterial: CarPaintMaterial })
const SSAARenderPass = require('../../../static/static-assets/eqc/three/SSAARenderPass')(THREE)
Object.assign(THREE, { SSAARenderPass: SSAARenderPass })
const TAARenderPass = require('../../../static/static-assets/eqc/three/TAARenderPass')(THREE)
Object.assign(THREE, { TAARenderPass: TAARenderPass })
const FXAA = require('../../../static/static-assets/eqc/three/FXAAShader')(THREE)
Object.assign(THREE, { FXAA: FXAA })
const BokehShader = require('../../../static/static-assets/eqc/three/BokehShader')(THREE)
Object.assign(THREE, { BokehShader: BokehShader })
const BokehPass = require('../../../static/static-assets/eqc/three/BokehPass')(THREE)
Object.assign(THREE, { BokehPass: BokehPass })
const OrbitControls = require('../../../static/static-assets/eqc/three/OrbitControls')(THREE)
Object.assign(THREE, { OrbitControls: OrbitControls })
window.THREE = THREE

// DEBUG WITH window.eqc
/*

Attach your external script to the scroll event:
window.eqc.scrollHooks.YOURNAME = (top) => { ... code here ... }

for (let key in window.eqc.mat) {
console.log(key + '.roughness: ' + window.eqc.mat[key].roughness)
console.log(key + '.metalness: ' + window.eqc.mat[key].metalness)
console.log(key + '.color.r: ' + window.eqc.mat[key].color.r)
console.log(key + '.color.g: ' + window.eqc.mat[key].color.g)
console.log(key + '.color.b: ' + window.eqc.mat[key].color.b)
console.log(key + '.emissive.r: ' + window.eqc.mat[key].emissive.r)
console.log(key + '.emissive.g: ' + window.eqc.mat[key].emissive.g)
console.log(key + '.emissive.b: ' + window.eqc.mat[key].emissive.b)
console.log(key + '.emissiveIntensity: ' + window.eqc.mat[key].emissiveIntensity)
console.log(key + '.opacity: ' + window.eqc.mat[key].opacity)
console.log(key + '.aoMapIntensity: ' + window.eqc.mat[key].aoMapIntensity)
}

 */
$(document).ready(function () {
  $('.eqc-3d').each(function (eqcCount, eqc3d) {
    let dom = {}
    let app = {
      params: {
        path: '/etc/designs/brandhub/frontend/static-assets/',
        useModel: true,
        usePostProcessing: true,
        quality: isMobile.any ? 'lq' : 'hq',
        clearColorSteps: [
          { r: 0, g: 0, b: 0 },
          { r: 15, g: 87, b: 127 },
          { r: 202, g: 135, b: 108 }
        ],
        clearColor: { r: 0, g: 0, b: 0 },
        ambientColor: { r: 255, g: 255, b: 255 },
        lightColor: { r: 0, g: 120, b: 255 },
        camera: {
          scroll: {
            offsetY: 0,
            angleY: 0
          },
          move: {
            offsetY: 0,
            offsetX: 0,
            maxX: 80,
            maxY: 40
          },
          near: 10,
          far: 10000,
          fov: 40,
          baseX: 0,
          baseY: 80, // intro animation!
          baseZ: 80,
          minY: 10,
          lookX: 0,
          lookY: 0, // intro animation!
          lookYBase: 10,
          lookZ: 0,
          lookAtTarget: true, // for scrolling
          orbit: false
        },
        sky: {
          width: 600, // vw
          max: 500, // vw movement (should be 100vw less than width
          intro: 200 // vw movement on first intro step
        },
        sun: {
          turbidity: 1.8,
          rayleigh: 2,
          mieCoefficient: 0.016,
          mieDirectionalG: 0.833,
          inclination: 0.510,
          luminance: 1,
          azimuth: 0.34,
          distance: 400000,
          theta: 0,
          phi: 0
        },
        page: {
          scrollTop: 0,
          winWidth: 0,
          winHeight: 0,
          topRange: false,
          topRangeClose: false,
          bottomRange: false,
          bottomRangeClose: false,
          topHeight: 0,
          bottomHeight: 0,
          canvasParallax: 0,
          ctaVisible: false
        },
        menu: {
          scrollTopEvent: 0,
          circleDashoffset: 0,
          progress: 0,
          open: false,
          animating: false,
          visitContentFirstTime: true,
          visitBottomFirstTime: true
        },
        intro: {
          cameraYStart: 80,
          cameraYEnd: 15, // ..camera.baseY
          lookYStart: 0,
          lookYEnd: 10, // ..camera.lookY
          ignoreInputs: true,
          running: false,
          done: false,
          skip: false
        },
        smoothScroll: {

        },
        loaded: {
          done: false,
          complete: 0,
          model: 0,
          textures: 0,
          sizes: {
            hq: 32977082,
            lq: 25560850
          }
        },
        anime: {}
      },
      timelines: {},
      scrollHooks: {}, // add your function to this object via -> window.eqc.scrollHooks.YOURNAME = (top) => { ... code here ... }
      init: () => {
        console.log('init ecq-3d')
        app.scroll = SmoothScroll.init(eqc3d, app.params.smoothScroll)
        setTimeout(() => {
          dom.window = $(window)
          dom.bodyHtml = $('body,html')
          dom.body = $('body')
          dom.html = $('html')
          dom.eqc3d = $(eqc3d)
          // canvas
          dom.canvasContainer = $('.eqc-3d--canvas')
          dom.canvas = dom.canvasContainer.find('canvas')
          dom.sky = dom.canvasContainer.find('.eqc-3d--sky')
          // content area
          dom.content = $('.eqc-3d--content')
          dom.container = $('.eqc-3d--container')
          dom.sections = dom.content.find('section')
          // header area
          dom.header = $('.eqc-3d--header')
          dom.headerClose = $('.eqc-3d--header-close')
          dom.more = dom.header.find('.eqc-3d--more')
          dom.title = dom.header.find('.eqc-3d--title')
          dom.headline = dom.title.children('.eqc-3d--headline')
          dom.headlineParts = dom.headline.children('div')
          dom.headlineLegal = dom.title.find('p')
          // footer area
          dom.footer = $('.eqc-3d--footer')
          dom.footerClose = $('.eqc-3d--footer-close')
          // menu
          dom.htmlHeader = $('header')
          dom.menu = $('.eqc-3d--menu')
          dom.menuButton = $('.eqc-3d--menu-button')
          dom.menuSvg = dom.menuButton.find('svg')
          dom.menuSvgProgress = dom.menuSvg.find('.scroll-progress')
          dom.menuSvgProgressBg = dom.menuSvg.find('.scroll-progress-bg')
          dom.menuSvgPulsate = dom.menuSvg.find('.scroll-pulsate')
          dom.menuSvgHover = dom.menuSvg.find('.scroll-hover')
          dom.cta = dom.eqc3d.find('.eqc-3d-cta')
          dom.stageCTA = dom.header.find('.eqc-3d-ctaStage')
          dom.stageCTALink = dom.stageCTA.find('a')
          dom.stageCTAPath = dom.stageCTA.find('path')
          dom.stageCTAGradient = dom.stageCTA.find('linearGradient')

          app.canvas = dom.canvas.get(0)

          if (isMobile.any) {
            dom.html.addClass('mobile')
            // switch off postprocessing on mobile for now
            app.params.usePostProcessing = false
            // device motion data
            app.motionData = {}
            app.motionData = new window.FULLTILT.DeviceOrientation({ type: 'game' })
            app.motionData.start(() => {
              let euler = app.motionData.getScreenAdjustedEuler()
              // app.params.settings.ROT_A = euler.alpha
              // app.params.settings.ROT_B = euler.beta // <- tilt up/down
              // app.params.settings.ROT_G = euler.gamma // <- tilt left/right
              let x = euler.gamma * 100 / 20
              let y = (euler.beta - 40) * 100 / 20
              TweenLite.to(app.params.camera.move, 0.7, {
                offsetX: (x < -100 ? -100 : x > 100 ? 100 : x) * -1,
                offsetY: y < -100 ? -100 : y > 100 ? 100 : y,
                ease: Power2.easeOutCubic
              })
            })
            if (isMobile.phone) {
              dom.html.addClass('phone')
            } else {
              dom.html.addClass('tablet')
            }
          } else {
            dom.html.addClass('desktop')
          }

          app.resize()
          app.preload()
          if (dom.canvas.length) {
            app.initSound()
            app.initMenu()
            app.initThree()
            // app.initCarpaint()
            app.initLights()
            app.initSky()
            app.initEnv()
            app.introReset()
          }
          app.observe()
          app.scrollPos()
          app.render()
          app.events()
        }, 300)
      },
      preload: () => {
        dom.preloadSvg = $('.eqc-3d--preloader-circle')
        dom.preloadCircles = dom.preloadSvg.find('circle')
        let sound = dom.preloadSvg.find('.preload-sound')
        dom.preloadSpeaker = sound.find('polygon')
        dom.preloadSpeakerBars = sound.find('path')
        app.params.loaded.circleDashoffset = anime.setDashoffset(dom.preloadCircles.get(0))
        dom.preloadCircles.eq(1).attr({
          'stroke-dasharray': app.params.loaded.circleDashoffset,
          'stroke-dashoffset': app.params.loaded.circleDashoffset,
          'opacity': 1
        })
        dom.preloadCircles.eq(2).attr({
          'stroke-dasharray': app.params.loaded.circleDashoffset,
          'stroke-dashoffset': app.params.loaded.circleDashoffset,
          'opacity': 1
        })
        app.params.loaded.animation = {
          dashOffset: app.params.loaded.circleDashoffset,
          dashArray: app.params.loaded.circleDashoffset,
          r: 0,
          speaker: 0,
          bar0: 0,
          bar1: 0
        }
        anime({
          targets: app.params.loaded.animation,
          dashOffset: [app.params.loaded.circleDashoffset, app.params.loaded.circleDashoffset / 1.7],
          duration: 1500,
          easing: 'easeInCubic',
          update: () => {
            dom.preloadCircles.eq(1).attr('stroke-dashoffset', app.params.loaded.animation.dashOffset)
          },
          complete: () => {
            if (!app.params.loaded.done) {
              anime({
                targets: app.params.loaded.animation,
                speaker: [0, 1],
                duration: 600,
                easing: 'easeOutCubic',
                update: () => {
                  dom.preloadSpeaker.attr('opacity', app.params.loaded.animation.speaker)
                },
                complete: () => {
                  if (!app.params.loaded.done) {
                    anime({
                      targets: app.params.loaded.animation,
                      bar0: [
                        { value: [0, 1], duration: 600, easing: 'easeInQuart' },
                        { value: [1, 0], duration: 600, easing: 'easeOutQuart', delay: 200 }
                      ],
                      bar1: [
                        { value: [0, 1], duration: 600, easing: 'easeInQuart', delay: 200 },
                        { value: [1, 0], duration: 600, easing: 'easeOutQuart', delay: 200 }
                      ],
                      loop: true,
                      update: () => {
                        dom.preloadSpeakerBars.eq(0).attr('opacity', app.params.loaded.animation.bar0)
                        dom.preloadSpeakerBars.eq(1).attr('opacity', app.params.loaded.animation.bar1)
                      }
                    })
                  }
                }
              })
            }
          }
        })
        anime({
          targets: app.params.loaded.animation,
          r: [0, 360],
          delay: 1200,
          duration: 1500,
          easing: 'easeInCubic',
          update: () => {
            dom.preloadCircles.eq(1).attr('transform', 'rotate(' + app.params.loaded.animation.r + ' 40 40)')
          },
          complete: () => {
            if (!app.params.loaded.done) {
              anime({
                targets: app.params.loaded.animation,
                r: [0, 360],
                duration: 1500,
                easing: 'linear',
                loop: true,
                update: () => {
                  dom.preloadCircles.eq(1).attr('transform', 'rotate(' + app.params.loaded.animation.r + ' 40 40)')
                }
              })
            }
          }
        })
      },
      preloadComplete: () => {
        app.params.loaded.done = true
        anime.remove(app.params.loaded.animation)
        anime({
          targets: app.params.loaded.animation,
          bar0: 0,
          bar1: 0,
          speaker: 0,
          duration: 600,
          easing: 'easeOutCubic',
          update: () => {
            dom.preloadSpeakerBars.eq(0).attr('opacity', app.params.loaded.animation.bar0)
            dom.preloadSpeakerBars.eq(1).attr('opacity', app.params.loaded.animation.bar1)
            dom.preloadSpeaker.attr('opacity', app.params.loaded.animation.speaker)
          }
        })
        anime({
          targets: app.params.loaded.animation,
          r: 360,
          dashOffset: app.params.loaded.circleDashoffset,
          dashArray: app.params.loaded.circleDashoffset * 2,
          duration: 1500,
          easing: 'easeInCubic',
          update: () => {
            dom.preloadCircles.eq(1).attr({
              'transform': 'rotate(' + app.params.loaded.animation.r + ' 40 40)',
              'stroke-dashoffset': app.params.loaded.animation.dashOffset,
              'stroke-dasharray': app.params.loaded.animation.dashArray
            })
          },
          complete: () => {
            anime({
              targets: dom.preloadCircles.get(2),
              strokeDashoffset: [app.params.loaded.circleDashoffset, 0],
              duration: 1500,
              easing: 'easeOutCubic',
              complete: () => {
                $('.eqc-3d--preloader').addClass('loaded')
                app.introBegin()
              }
            })
          }
        })
      },
      events: () => {
        app.resize()
        dom.window
          .on('scroll', (e) => {
            // app.scrollPos()
          })
          .on('mousemove', (e) => {
            if (!app.params.intro.running && !isMobile.any && !app.controls.enabled) {
              let x = (e.pageX * 100 / app.params.page.winWidth - 50) * 2
              let y = (e.pageY * 100 / app.params.page.winHeight - 50) * 2
              TweenLite.to(app.params.camera.move, 0.7, {
                offsetX: (x < -100 ? -100 : x > 100 ? 100 : x) * -1,
                offsetY: y < -100 ? -100 : y > 100 ? 100 : y,
                ease: Power2.easeOutCubic,
                onBegin: () => {
                  // app.pass.ssaa.enabled = false
                },
                onComplete: () => {
                  // app.pass.ssaa.enabled = true
                }
              })
            }
          })
        if (!app.params.useModel && 'renderer' in app) {
          app.introBegin()
        }
        $(window).on('resize', app.resize)
      },
      resize: () => {
        app.params.page.winWidth = dom.window.innerWidth()
        app.params.page.winHeight = dom.window.innerHeight()
        app.params.page.topHeight = dom.header.height()
        app.params.page.bottomHeight = dom.footer.height()
        if ('renderer' in app) {
          app.recalcAspectRatio()
          app.renderer.setSize(app.canvas.offsetWidth, app.canvas.offsetHeight, false)
          app.composer.setSize(app.canvas.offsetWidth * 2, app.canvas.offsetHeight * 2)
          if ('gltf' in app) {
            app.gltf.scale.setScalar(app.params.page.winWidth * (app.params.page.winWidth < 768 ? 130 : 45) / 2000)
          }
          if ('bloom' in app.pass) {
            app.pass.bloom.resolution.x = app.params.page.winWidth * app.renderer.getPixelRatio()
            app.pass.bloom.resolution.y = app.params.page.winHeight * app.renderer.getPixelRatio()
          }
          app.updateCamera()
        }
        app.scrollPos()
      },
      onIntersection: (elements) => {
        // loop through observed elements
        for (let el of elements) {
          // get the app.params.page.XXX param to set to true/false if in observe range
          let data = typeof el.target.dataset !== 'undefined' && 'observe' in el.target.dataset ? el.target.dataset.observe : ''
          if (el.intersectionRatio > 0) {
            // console.log(el.target.nodeName, el.target)
          }
          if (data) {
            app.params.page[data] = el.intersectionRatio > 0
            app.params.page[data] ? dom.body.addClass(data) : dom.body.removeClass(data)
            // console.log(data, el.intersectionRatio)
          }
        }
      },
      observe: () => {
        app.observer = new IntersectionObserver(app.onIntersection, { rootMargin: '0px 0px', threshold: [0, 0.01, 0.03, 0.06, 0.1, 0.2] })
        app.observer.observe(dom.header.get(0))
        app.observer.observe(dom.footer.get(0))
        app.observer.observe(dom.headerClose.get(0))
        app.observer.observe(dom.footerClose.get(0))
        // observe sections for blur
        dom.sections.each((index, element) => {
          app.observer.observe($(element).get(0))
        })
      },
      scrollPos: () => {
        let top = app.scroll.scrollTop // dom.bodyHtml.scrollTop()

        // app.params.page.inTopRange = top < app.params.page.winHeight * 1.1
        // app.params.page.nearTopRange = top > app.params.page.winHeight * 1.1 && top < app.params.page.winHeight * 1.5 && !app.params.page.inTopRange
        // app.params.page.inBottomRange = top >= dom.content.height() - app.params.page.winHeight
        // app.params.page.nearBottomRange = top > domOffset + domHeight - (app.params.page.winHeight * 1.5) && top < domOffset + domHeight - app.params.page.winHeight && !app.params.page.inBottomRange

        if (top !== app.params.page.scrollTop) {
          let p = top * 100 / app.canvas.offsetHeight
          p = p > 100 ? p = 100 : p < 0 ? p = 0 : p

          // first time out of topRange
          if (!app.params.page.topRange && app.params.page.topRangeClose) {
            if (app.params.menu.visitContentFirstTime) {
              app.params.menu.visitContentFirstTime = false
              app.timelines.menuPulsate.restart()
            }
          }

          // animate the camera position according to the scroll position - depending on the current page part (header or footer)
          if (app.params.page.topRange) {
            app.params.camera.lookAtTarget = true
            app.params.camera.scroll.offsetY = p
            dom.more.height(top / 3)
            if (app.params.intro.done) {
              dom.sky.css({ 'transform': 'translateX(-500vw) translateZ(0)' })
            }
            // header section parallax for canvas
            app.params.page.canvasParallax = top / 1.1
            TweenLite.to(dom.canvasContainer, 0.01, {
              css: {
                transform: 'translate3d(0,-' + app.params.page.canvasParallax + 'px, 0)'
              }
            })
            // CTA
            if (app.params.page.ctaVisible) {
              if (top < 300) {
                app.params.page.ctaVisible = false
                dom.cta.removeClass('view')
              }
            } else {
              if (top > 300) {
                app.params.page.ctaVisible = true
                dom.cta.addClass('view')
              }
            }
          } else if (app.params.page.bottomRange) {
            // reset canvas parallax movement
            if (app.params.page.canvasParallax > 0) {
              app.params.page.canvasParallax = 0
              TweenLite.to(dom.canvasContainer, 0.01, {
                css: {
                  transform: 'translate3d(0,-' + app.params.page.canvasParallax + 'px, 0)'
                }
              })
            }
            // first time bottom visit
            if (app.params.menu.visitBottomFirstTime) {
              app.params.menu.visitBottomFirstTime = false
              app.timelines.menuPulsate.restart()
            }

            app.params.camera.lookAtTarget = true
            let bottomOffset = dom.footer.offset().top
            // let fromBottom = top - (bottomOffset + app.params.page.bottomHeight - app.params.page.winHeight) // add 3x height to content height (for canvas visibility) - 1x height (for winHeight)
            let p = ((bottomOffset + app.params.page.bottomHeight) * 100 / app.params.page.winHeight) - 100
            app.params.camera.scroll.offsetY = p * -3
            app.params.camera.scroll.angleY = p * -1
            p = (((bottomOffset + app.params.page.bottomHeight + app.params.page.winHeight) * 100 / app.params.page.winHeight) - 200) / 2
            let x = -app.params.sky.max + (p * app.params.sky.max / 100)
            dom.sky.css({ 'transform': 'translateX(' + (x < -app.params.sky.max ? -app.params.sky.max : x > 0 ? 0 : x) + 'vw) translateZ(0)' })
          } else if (app.params.page.topRangeClose) {
          } else if (app.params.page.bottomRangeClose) {
          }
          Object.keys(app.scrollHooks).forEach((hook, i) => {
            // hook(app.params.page.scrollTop)
            app.scrollHooks[hook](app.params.page.scrollTop)
          })
          // header
          if (top - app.params.menu.scrollTopEvent > 50) {
            app.params.menu.scrollTopEvent = top
            dom.htmlHeader.addClass('hide')
          }
          if (top - app.params.menu.scrollTopEvent < app.params.page.winHeight / -3) {
            app.params.menu.scrollTopEvent = top
            dom.htmlHeader.removeClass('hide')
          }
          if (top <= 50) {
            dom.htmlHeader.removeClass('hide')
          }
        }
        app.params.page.scrollTop = top
        let scrollProgress = top * 100 / (('nice' in app ? app.nice.getContentSize().h : app.scroll.size.content.height) - app.params.page.winHeight)
        if (app.params.menu.progress !== scrollProgress) {
          app.params.menu.progress = scrollProgress
          TweenLite.to(dom.menuSvgProgress, 0.4, {
            strokeDashoffset: app.params.menu.circleDashoffset - (scrollProgress * app.params.menu.circleDashoffset / 100),
            ease: Power2.easeOutCubic
          })
        }
      },
      recalcAspectRatio: () => {
        app.aspectRatio = (app.canvas.offsetHeight === 0) ? 1 : app.canvas.offsetWidth / app.canvas.offsetHeight
      },
      datGui: () => {
        app.gui = new dat.GUI()
        app.params.settings = {
          material: '',
          roughness: 0,
          metalness: 0,
          color: [0, 0, 0],
          opacity: 0,
          emissive: [0, 0, 0],
          emissiveIntensity: 1,
          aomapIntensity: 1,
          normalScale: 0,
          toneMappingExposure: app.renderer.toneMappingExposure,
          bloomThreshold: app.pass.bloom.threshold,
          bloomStrength: app.pass.bloom.strength,
          bloomRadius: app.pass.bloom.radius,
          light: 1,
          lightColor: [1, 1, 1],
          ACC_X: '',
          ACC_Y: '',
          ACC_Z: '',
          ROT_A: '',
          ROT_B: '',
          ROT_G: ''
        }
        app.guiCamera = app.gui.addFolder('Camera Controls')
        app.guiCamera.add(app.controls, 'enabled').listen()
        app.guiMaterial = app.gui.addFolder('Material')
        app.guiController = app.guiMaterial.add(app.params.settings, 'material', Object.keys(app.mat))
        app.guiRoughness = app.guiMaterial.add(app.params.settings, 'roughness', 0, 1, 0.01).listen()
        app.guiMetalness = app.guiMaterial.add(app.params.settings, 'metalness', 0, 1, 0.01).listen()
        app.guiColor = app.guiMaterial.addColor(app.params.settings, 'color').listen()
        app.guiEmissive = app.guiMaterial.addColor(app.params.settings, 'emissive').listen()
        app.guiEmissiveIntensity = app.guiMaterial.add(app.params.settings, 'emissiveIntensity', 0, 5, 0.01).listen()
        app.guiOpacity = app.guiMaterial.add(app.params.settings, 'opacity', 0, 1, 0.01).listen()
        app.guiAoMapIntensity = app.guiMaterial.add(app.params.settings, 'aomapIntensity', 0, 2, 0.01).listen()
        app.guiNormalScale = app.guiMaterial.add(app.params.settings, 'normalScale', -1, 1, 0.01).listen()

        app.guiPostprocessing = app.gui.addFolder('Postprocessing')
        app.guiPostprocessing.add(app.params, 'usePostProcessing', true, false)
        app.guiBloomThreshold = app.guiPostprocessing.add(app.params.settings, 'bloomThreshold', 0, 1, 0.01).listen()
        app.guiBloomStrength = app.guiPostprocessing.add(app.params.settings, 'bloomStrength', 0, 2, 0.1).listen()
        app.guiBloomRadius = app.guiPostprocessing.add(app.params.settings, 'bloomRadius', 0, 1, 0.01).listen()
        app.guiToneMappingExposure = app.guiPostprocessing.add(app.params.settings, 'toneMappingExposure', 0, 3, 0.05).listen()
        app.guiLight = app.guiPostprocessing.add(app.params.settings, 'light', 0, 3, 0.1).listen()
        app.guiLightColor = app.guiPostprocessing.addColor(app.params.settings, 'lightColor').listen()

        if ('motionData' in app) {
          app.guiMobile = app.gui.addFolder('Mobile')
          app.guiMobile.add(app.params.settings, 'ACC_X').listen()
          app.guiMobile.add(app.params.settings, 'ACC_Y').listen()
          app.guiMobile.add(app.params.settings, 'ACC_Z').listen()
          app.guiMobile.add(app.params.settings, 'ROT_A').listen()
          app.guiMobile.add(app.params.settings, 'ROT_B').listen()
          app.guiMobile.add(app.params.settings, 'ROT_G').listen()
        }
        // events
        app.guiController.onChange((value) => {
          console.log('guiController', value)
          app.params.settings.roughness = app.mat[value].roughness
          app.params.settings.metalness = app.mat[value].metalness
          app.params.settings.color = [app.rgbOut(app.mat[value].color.r), app.rgbOut(app.mat[value].color.g), app.rgbOut(app.mat[value].color.b)]
          app.params.settings.opacity = app.mat[value].opacity
          app.params.settings.aomapIntensity = app.mat[value].aoMapIntensity
        })
        app.guiColor.onChange((value) => {
          app.mat[app.params.settings.material].color.r = app.rgbIn(value[0])
          app.mat[app.params.settings.material].color.g = app.rgbIn(value[1])
          app.mat[app.params.settings.material].color.b = app.rgbIn(value[2])
        })
        app.guiEmissive.onChange((value) => {
          app.mat[app.params.settings.material].emissive.r = app.rgbIn(value[0])
          app.mat[app.params.settings.material].emissive.g = app.rgbIn(value[1])
          app.mat[app.params.settings.material].emissive.b = app.rgbIn(value[2])
        })
        app.guiRoughness.onChange((value) => { app.mat[app.params.settings.material].roughness = value })
        app.guiMetalness.onChange((value) => { app.mat[app.params.settings.material].metalness = value })
        app.guiOpacity.onChange((value) => { app.mat[app.params.settings.material].opacity = value })
        app.guiEmissiveIntensity.onChange((value) => { app.mat[app.params.settings.material].emissiveIntensity = value })
        app.guiAoMapIntensity.onChange((value) => { app.mat[app.params.settings.material].aoMapIntensity = value })
        app.guiNormalScale.onChange((value) => { app.mat[app.params.settings.material].normalScale.set(1, -1).multiplyScalar(value) })
        app.guiToneMappingExposure.onChange((value) => { app.renderer.toneMappingExposure = value })
        app.guiBloomThreshold.onChange((value) => { app.pass.bloom.threshold = value })
        app.guiBloomStrength.onChange((value) => { app.pass.bloom.strength = value })
        app.guiBloomRadius.onChange((value) => { app.pass.bloom.radius = value })
        app.guiLight.onChange((value) => { app.light.scene.intensity = value })
        app.guiLightColor.onChange((value) => {
          app.light.scene.color.r = app.rgbIn(value[0])
          app.light.scene.color.g = app.rgbIn(value[1])
          app.light.scene.color.b = app.rgbIn(value[2])
        })
      },
      initSound: () => {
        app.sound = {
          loaded: 0,
          toLoad: 2,
          muted: false,
          button: dom.header.find('.eqc-3d--sound'),
          volume1: 0,
          volume2: 0,
          play: () => {
            app.sound.loop1.play()
            app.sound.loop2.play()
            TweenLite.to(app.sound, 8, {
              volume1: 1,
              ease: 'linear',
              onUpdate: () => {
                app.sound.loop1.volume(app.sound.volume1)
              }
            })
            TweenLite.to(app.sound, 16, {
              volume2: 1,
              ease: 'linear',
              onUpdate: () => {
                app.sound.loop2.volume(app.sound.volume2)
              }
            })
            app.sound.button.on('click', app.sound.mute)
          },
          mute: () => {
            if (!app.sound.muted) {
              app.sound.muted = true
              app.sound.button.addClass('off')
              app.sound.loop1.stop()
              app.sound.loop2.stop()
            } else {
              app.sound.muted = false
              app.sound.button.removeClass('off')
              app.sound.loop1.play()
              app.sound.loop2.play()
            }
          },
          loop1: new Howl({
            src: [app.params.path + 'eqc/audio/loop1.ogg', app.params.path + 'eqc/audio/loop1.wav'],
            autoplay: false,
            volume: 0,
            loop: true,
            onload: () => {
              app.sound.loaded++
              if (app.sound.loaded === app.sound.toLoad) {
                app.sound.play()
              }
            }
          }),
          loop2: new Howl({
            src: [app.params.path + 'eqc/audio/loop2.ogg', app.params.path + 'eqc/audio/loop2.wav'],
            autoplay: false,
            volume: 0,
            loop: true,
            onload: () => {
              app.sound.loaded++
              if (app.sound.loaded === app.sound.toLoad) {
                app.sound.play()
              }
            }
          })
        }
        app.scrollHooks.sound = (top) => {
          let end = app.params.page.winHeight
          if (top > end && app.sound.volume1 > 0) {
            TweenLite.to(app.sound, 0.5, {
              volume1: 0,
              volume2: 0,
              ease: 'linear',
              onUpdate: () => {
                app.sound.loop1.volume(app.sound.volume1)
                app.sound.loop2.volume(app.sound.volume2)
              }
            })
          } else if (top > app.params.page.winHeight / 2 && top < end && app.sound.volume1 < 1) {
            TweenLite.to(app.sound, 0.5, {
              volume1: 1,
              volume2: 1,
              ease: 'linear',
              onUpdate: () => {
                app.sound.loop1.volume(app.sound.volume1)
                app.sound.loop2.volume(app.sound.volume2)
              }
            })
          }
        }
      },
      initCarpaint: () => {
        app.carpaint = {
          shader: {
            uniforms: THREE.UniformsUtils.merge([
              THREE.UniformsLib.common,
              THREE.UniformsLib.envmap,
              THREE.UniformsLib.aomap,
              THREE.UniformsLib.lightmap,
              THREE.UniformsLib.emissivemap,
              THREE.UniformsLib.bumpmap,
              THREE.UniformsLib.normalmap,
              THREE.UniformsLib.displacementmap,
              THREE.UniformsLib.roughnessmap,
              THREE.UniformsLib.metalnessmap,
              THREE.UniformsLib.fog,
              THREE.UniformsLib.lights,
              { // standard
                emissive: {value: new THREE.Color(0, 0, 0)},
                roughness: {value: 0.5},
                metalness: {value: 0.5},
                envMapIntensity: {value: 1} // temporary
              }, // physical
              {
                clearCoat: {value: 0},
                clearCoatRoughness: {value: 0}
              },
              {
                diffuseColor2: {value: new THREE.Color(0, 0, 0)},
                normalUVScale: {value: 1.0}
              }]),
            load: (callback) => {
              console.log(app.params.path + 'CarPaintVertex.glsl')
              app.loaders.fileLoader.load(app.params.path + 'three/CarPaintVertex.glsl',
                (code) => {
                  app.carpaint.shader.vertexShader = code
                  console.log(app.params.path + 'CarPaintFragment.glsl')
                  app.loaders.fileLoader.load(app.params.path + 'three/CarPaintFragment.glsl',
                    (code) => {
                      app.carpaint.shader.fragmentShader = code
                      if (typeof callback !== 'undefined') {
                        callback()
                      }
                    })
                })
            }
          },
          flakes: app.loaders.textureLoader.load(app.params.path + 'eqc/model/flakes_extreme.jpg')
        }
        app.carpaint.shader.load()
      },
      initSky: () => {
        app.sky = {
          obj: null,
          sun: null,
          vertex: '',
          fragment: ''
        }
        // app.loaders.fileLoader.load(app.params.path + 'three/SkyVertex.glsl', (code) => {
        //   app.sky.vertex = code
        //   if (app.sky.fragment) {
        //     app.createSky()
        //   }
        // })
        // app.loaders.fileLoader.load(app.params.path + 'three/SkyFragment.glsl', (code) => {
        //   app.sky.fragment = code
        //   if (app.sky.vertex) {
        //     app.createSky()
        //   }
        // })
      },
      createSky: () => {
        // app.sky.obj = new THREE.Sky()
        // app.sky.sun = new THREE.Mesh(new THREE.SphereBufferGeometry(20000, 16, 8), new THREE.MeshBasicMaterial({ color: 0xffffff }))
        // app.sky.sun.visible = false
        // app.scene.add(app.sun)
        // app.sky.obj.material.uniforms.turbidity.value = app.params.sun.turbidity
        // app.sky.obj.material.uniforms.rayleigh.value = app.params.sun.rayleigh
        // app.sky.obj.material.uniforms.mieCoefficient.value = app.params.sun.mieCoefficient
        // app.sky.obj.material.uniforms.mieDirectionalG.value = app.params.sun.mieDirectionalG
        // app.sky.obj.material.uniforms.luminance.value = app.params.sun.luminance
        // app.scene.add(app.sky.obj)
        // app.scene.add(app.sky.sun)
        // app.calcSun()
      },
      calcSun: () => {
        app.params.sun.theta = Math.PI * (app.params.sun.inclination - 0.5)
        app.params.sun.phi = 2 * Math.PI * (app.params.sun.azimuth - 0.5)
        app.sky.sun.position.x = app.params.sun.distance * Math.cos(app.params.sun.phi)
        app.sky.sun.position.y = app.params.sun.distance * Math.sin(app.params.sun.phi) * Math.sin(app.params.sun.theta)
        app.sky.sun.position.z = app.params.sun.distance * Math.sin(app.params.sun.phi) * Math.cos(app.params.sun.theta)
        app.sky.obj.material.uniforms.sunPosition.value.copy(app.sky.sun.position)
      },
      introReset: () => {
        app.params.intro.done = false
        // clear all animations
        let dashoffset = anime.setDashoffset(dom.stageCTAPath.get(0))
        dom.stageCTAPath.attr({
          'stroke-dasharray': dashoffset,
          'stroke-dashoffset': dashoffset,
          'opacity': 1
        })
        anime.remove(dom.sky.get(0))
        anime.remove(dom.headline.get(0))
        anime.remove(dom.headlineParts.get())
        anime.remove(dom.headlineLegal.get())
        anime.remove(app.light.ambient)
        anime.remove(app.light.scene)
        // anime.remove(app.mat.city.color)
        let lights = [app.light.ambient, app.light.scene]

        // reset sky
        anime({
          targets: dom.sky.get(0),
          translateX: [0, 0],
          translateZ: [0, 0],
          duration: 0
        })
        // anime({
        //   targets: app.mat.sky.color,
        //   r: [0, 0],
        //   g: [0, 0],
        //   b: [0, 0],
        //   duration: 0
        // })
        // reset light
        anime({
          targets: lights,
          intensity: [0, 0],
          duration: 0,
          easing: 'linear'
        })
        // reset font
        anime({
          targets: dom.headline.find('span').get(),
          opacity: [0, 0],
          duration: 0,
          easing: 'linear'
        })
        anime({
          targets: dom.headlineLegal.get(),
          opacity: [0, 0],
          duration: 0,
          easing: 'linear'
        })
        dom.more.removeClass('view')
        'nice' in app ? app.nice.doScrollTop(0) : app.scroll.scrollTo(0, 0, 500)
      },
      introBegin: () => {
        let baseDelay = 2000
        app.timelines.intro = anime.timeline({
          autoplay: true
        })
        app.timelines.intro
          .add({
            targets: app.renderer,
            toneMappingExposure: [0, 1.75],
            duration: app.params.intro.skip ? 0 : 4000,
            easing: 'linear'
          })
          .add({
            offset: 0,
            targets: app.light.scene,
            intensity: [0, 0.5],
            duration: app.params.intro.skip ? 0 : 8000,
            easing: 'linear'
          })
          .add({
            offset: 0,
            targets: app.light.scene.color,
            r: [1, app.rgbIn(49)],
            g: [1, app.rgbIn(40)],
            b: [1, app.rgbIn(61)],
            duration: app.params.intro.skip ? 0 : 7000,
            delay: app.params.intro.skip ? 0 : 3000,
            easing: 'easeInOutQuad'
          })
          // .add({
          //   offset: 0,
          //   targets: app.mat.city.color,
          //   r: [1, 1],
          //   g: [1, 0.7],
          //   b: [1, 0.9],
          //   duration: 7000,
          //   delay: 3000,
          //   easing: 'easeInOutQuad'
          // })
          // .add({
          //   offset: 0,
          //   targets: app.mat.CarPaint.color,
          //   r: [1, 1],
          //   g: [1, 0.7],
          //   b: [1, 0.9],
          //   duration: 7000,
          //   delay: 3000,
          //   easing: 'easeInOutQuad'
          // })
          .add({
            offset: 0,
            targets: app.params.camera,
            baseY: [app.params.intro.cameraYStart, app.params.intro.cameraYEnd],
            lookY: [app.params.intro.lookYStart, app.params.intro.lookYEnd],
            duration: app.params.intro.skip ? 0 : 6000,
            easing: 'easeInOutCubic',
            begin: () => {
              console.log('play intro')
              app.introReset()
              app.params.intro.running = true
            }
          })
          .add({
            offset: 6000,
            targets: dom.menuSvgProgressBg.get(0),
            strokeDashoffset: [anime.setDashoffset, 0],
            opacity: [0, 0.3],
            duration: app.params.intro.skip ? 0 : 2000,
            easing: 'easeInOutQuart',
            complete: () => {
              app.timelines.menuPulsate.restart()
            }
          })
          .add({
            offset: app.params.intro.skip ? 0 : 6000,
            targets: dom.menuSvgHover.get(),
            opacity: [0, 1],
            duration: 0
          })
          // .add({
          //   offset: 0,
          //   targets: [app.light.dir, app.light.dir2],
          //   intensity: [0, 0.7],
          //   duration: 2000,
          //   delay: (el, i, l) => {
          //     return i * 500
          //   },
          //   easing: 'linear'
          // })
          // .add({
          //   offset: 0,
          //   targets: [app.light.dir3, app.light.dir4],
          //   intensity: [0, 2],
          //   duration: 2000,
          //   delay: 700,
          //   easing: 'linear'
          // })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay + 4000,
            targets: app.mat.Front_Lights.emissive,
            r: 1,
            g: 1,
            b: 1,
            duration: app.params.intro.skip ? 0 : 3000,
            easing: 'linear'
          })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay,
            targets: dom.sky.get(0),
            translateX: [0, '-' + app.params.sky.intro + 'vw'],
            translateZ: [0, 0],
            duration: app.params.intro.skip ? 0 : 1000,
            easing: 'linear'
          })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay,
            targets: app.params.sun,
            inclination: [0.510, 0.4857],
            luminance: [1.1, 0.1],
            rayleigh: [0.1, 2],
            duration: app.params.intro.skip ? 0 : 8000,
            easing: 'easeInCubic',
            update: () => {
              // app.sky.obj.material.uniforms.luminance.value = app.params.sun.luminance
              // app.sky.obj.material.uniforms.rayleigh.value = app.params.sun.rayleigh
              // app.calcSun()
            }
          })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay + 4000,
            targets: app.light.ambient,
            intensity: [0, 0],
            duration: app.params.intro.skip ? 0 : 4000,
            easing: 'easeInCubic'
          })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay + 1000,
            targets: dom.headline.get(0),
            translateY: [40, 0],
            translateZ: [0, 0],
            duration: app.params.intro.skip ? 0 : 5000,
            easing: 'linear',
            begin: () => {
              dom.headlineParts.each((index, element) => {
                anime({
                  targets: $(element).children('span').get(),
                  opacity: [0, 1],
                  translateZ: [0, 0],
                  translateY: [100, 0],
                  duration: (el, i, l) => {
                    return app.params.intro.skip ? 0 : 4000 - i * 500
                  },
                  delay: (el, i, l) => {
                    return app.params.intro.skip ? 0 : 1000 + i * 500 + (5000 * index)
                  },
                  easing: 'easeOutQuart',
                  complete: () => {
                    if (index < dom.headlineParts.length - 1) {
                      anime({
                        targets: $(element).children('span').get(),
                        opacity: [1, 0],
                        translateY: [0, -50],
                        delay: 800,
                        duration: app.params.intro.skip ? 0 : 1000,
                        easing: 'easeOutQuart'
                      })
                    }
                    if (index === dom.headlineParts.length - 1) {
                      anime({
                        targets: dom.headlineLegal.get(),
                        opacity: [0, 1],
                        duration: app.params.intro.skip ? 0 : 1000,
                        easing: 'linear'
                      })
                    }
                  }
                })
              })
            }
          })
          .add({
            offset: app.params.intro.skip ? 0 : baseDelay + 5000,
            targets: dom.sky.get(0),
            translateX: ['-' + app.params.sky.intro + 'vw', '-' + app.params.sky.max + 'vw'],
            translateZ: [0, 0],
            duration: app.params.intro.skip ? 0 : 3000,
            easing: 'easeInOutCubic',
            complete: () => {
              app.moreShow()
            }
          })
      },
      moreShow: () => {
        dom.stageCTA.addClass('view')
        TweenLite.to(dom.stageCTAPath, 1, {
          strokeDashoffset: 0,
          ease: Power2.easeInOutCubic,
          onComplete: () => {
            dom.more.addClass('view')
            let scroll = { y: 0 }
            anime({
              targets: scroll,
              y: 30,
              easing: 'easeOutCubic',
              duration: 3000,
              update: () => {
                'nice' in app ? app.nice.doScrollTop(scroll.y, 0) : app.scroll.scrollTo(0, scroll.y, 0)
              },
              complete: () => {
                app.params.intro.done = true
                app.params.intro.running = false
                dom.more.on('click', (e) => {
                  'nice' in app ? app.nice.doScrollTop(app.params.page.winHeight) : app.scroll.scrollTo(0, app.params.page.winHeight, 2000)
                })
                dom.eqc3d.addClass('scrollable')
              }
            })
          }
        })
        let fy = { x1: 0, y1: 0, x2: 100, y2: 100 }
        let duration = 1
        dom.stageCTALink.on('mouseenter', (e) => {
          TweenLite.to(fy, duration, {
            x1: 100,
            x2: 0,
            ease: Power2.easeOutCubic,
            onUpdate: () => {
              dom.stageCTAGradient.attr({
                x1: fy.x1 + '%',
                y1: fy.y1 + '%'
              })
            }
          })
          TweenLite.to(fy, duration, {
            delay: duration / 2,
            y1: 100,
            y2: 0,
            ease: Power2.easeInCubic,
            onUpdate: () => {
              dom.stageCTAGradient.attr({
                x2: fy.x2 + '%',
                y2: fy.y2 + '%'
              })
            }
          })
        }).on('mouseleave', (e) => {
          TweenLite.to(fy, duration, {
            x1: 0,
            x2: 100,
            ease: Power2.easeOutCubic,
            onUpdate: () => {
              dom.stageCTAGradient.attr({
                x1: fy.x1 + '%',
                y1: fy.y1 + '%'
              })
            }
          })
          TweenLite.to(fy, duration, {
            delay: duration / 2,
            y1: 0,
            y2: 100,
            ease: Power2.easeInCubic,
            onUpdate: () => {
              dom.stageCTAGradient.attr({
                x2: fy.x2 + '%',
                y2: fy.y2 + '%'
              })
            }
          })
        })
      },
      rgbIn: (color) => {
        return color / 255
      },
      rgbOut: (color) => {
        return color * 255
      },
      initThree: () => {
        app.loaders = {}
        app.loaders.fileLoader = new THREE.FileLoader()
        app.loaders.textureLoader = new THREE.TextureLoader()
        app.loaders.cubeLoader = new THREE.CubeTextureLoader()
        app.loaders.hdrCubeLoader = new HDRCubeTextureLoader(app.loaders.cubeLoader.manager)
        app.loaders.gltf = new GLTFLoader()
        // app.loaders.fbx = new FBXLoader()
        app.mat = {}
        app.geo = {}
        app.mesh = {}
        app.light = {}
        app.renderer = null
        app.scene = null
        app.camera = null
        app.controls = null
        app.recalcAspectRatio()
        app.loaders.file = new THREE.Loader()
        app.cameraTarget = new THREE.Vector3(app.params.camera.lookX, app.params.camera.lookY, app.params.camera.lookZ)
        app.cameraTargetScroll = new THREE.Vector3(app.params.camera.lookX, app.params.camera.lookY, app.params.camera.lookZ)
        app.renderer = new THREE.WebGLRenderer({
          canvas: app.canvas,
          alpha: true,
          antialias: true,
          autoClear: false
        })
        app.renderer.setPixelRatio(isMobile.any ? window.devicePixelRatio : 1.5)
        app.renderer.gammaInput = true
        app.renderer.gammaOutput = true
        app.renderer.toneMapping = THREE.LinearToneMapping // THREE.LinearToneMapping
        app.renderer.toneMappingExposure = 1
        app.renderer.setClearColor(new THREE.Color(app.rgbIn(app.params.clearColor.r), app.rgbIn(app.params.clearColor.g), app.rgbIn(app.params.clearColor.b)), 0)
        app.renderer.shadowMap.enabled = true
        // app.renderer.shadowMap.type = THREE.PCFSoftShadowMap
        app.scene = new THREE.Scene()
        app.sceneBackground = new THREE.Scene()
        app.sceneForeground = new THREE.Scene()
        app.scene.add(app.sceneBackground)
        app.scene.add(app.sceneForeground)
        app.initCamera()
        app.controls = new OrbitControls(app.camera)
        app.controls.enabled = false
        app.controls.enableKeys = true
        app.controls.enablePan = true
        app.controls.enableZoom = true
        app.controls.maxAzimuthAngle = Math.PI / 4
        app.controls.minAzimuthAngle = Math.PI / -2.5
        app.controls.maxPolarAngle = Math.PI / 2.3
        app.controls.minPolarAngle = 0.5
        app.postprocessing()
      },
      genCubeUrls: (prefix, postfix) => {
        return [
          prefix + 'px' + postfix, prefix + 'nx' + postfix,
          prefix + 'py' + postfix, prefix + 'ny' + postfix,
          prefix + 'pz' + postfix, prefix + 'nz' + postfix
        ]
      },
      initEnv: () => {
        app.standardMaterial = new THREE.MeshStandardMaterial({
          map: null,
          color: 0xffffff,
          metalness: 1.0
        })
        app.envMap = app.standardMaterial.envMap
        app.loaders.hdrCubeLoader.load(THREE.UnsignedByteType, app.genCubeUrls(app.params.path + 'eqc/model/' + app.params.quality + '/HDRI_Cube/', '.hdr'), (hdrCubeMap) => {
          console.log('env loaded')
          let pmremGenerator = new PMREMGenerator(hdrCubeMap)
          pmremGenerator.update(app.renderer)
          let pmremCubeUVPacker = new PMREMCubeUVPacker(pmremGenerator.cubeLods)
          pmremCubeUVPacker.update(app.renderer)
          app.hdrCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget

          let newEnvMap = app.standardMaterial.envMap
          if (app.hdrCubeRenderTarget) {
            newEnvMap = app.hdrCubeRenderTarget.texture
          }
          if (newEnvMap !== app.standardMaterial.envMap) {
            app.envMap = newEnvMap
          }
          app.initModel()
        })
      },
      initModel: () => {
        console.log('init model')
        app.aoMapTires = app.loaders.textureLoader.load(app.params.path + 'eqc/model/' + app.params.quality + '/Tire_ao.jpg')
        app.aoMapExterior = app.loaders.textureLoader.load(app.params.path + 'eqc/model/' + app.params.quality + '/Exterior_ao2.jpg', () => {
          app.loaders.gltf.load(app.params.path + 'eqc/model/' + app.params.quality + '/EQC_Model.gltf', (code) => {
            code.scene.traverse((child) => {
              if (child.isMesh) {
                // child.material.envMap = envMap;
                // app.scene.add(child)
                child.material.light = true
                let ao = [
                  'CarPaint_Silver',
                  'Chromes_Exterior',
                  'Chromes_Light_Exterior',
                  'Rear_Lights_Reflector',
                  'Mirrors',
                  'Chrome_Blue_Front_Lights',
                  'Front_Lights',
                  'Rear_Lights_Main',
                  'Mask_Exterior',
                  'Exterior_Plastic',
                  'Exterior_Plastic 1',
                  'Exterior_Plastic_2'
                ]
                if (ao.includes(child.material.name)) {
                  // let geo = new THREE.Geometry().fromBufferGeometry(child.geometry)
                  // geo.faceVertexUvs.push(geo.faceVertexUvs[0])
                  // child.geometry.fromGeometry(geo)
                  // console.log('new geometry', child.name, geo)
                }
                if (child.material.name && !(child.material.name in app.mat)) {
                  if (ao.includes(child.material.name)) {
                    child.material.aoMap = app.aoMapExterior
                  }
                  // child.material.envMap = app.envMap
                  child.material.envMap = app.envMap
                  if (child.material.name === 'Tire 1') {
                    child.material.aoMap = app.aoMapTires
                    child.material.color = new THREE.Color(0x333333)
                  }
                  if (child.material.name === 'Ground' || child.material.name === 'Skydome') {
                    child.material.metalness = 0
                    child.material.roughness = 1
                  }
                  if (child.material.name === 'Chromes_Exterior') {
                    child.material.color = new THREE.Color(0xFFFFFF)
                    child.material.aoMapIntensity = 0.2
                  }
                  if (child.material.name === 'CarPaint_Silver') {
                    child.material.color = new THREE.Color(0xAAAAAA)
                  }
                  if (child.material.name === 'Interior_Plastic') {
                    child.material.metalness = 1
                    child.material.roughness = 0.8
                  }
                  app.mat[child.material.name] = child.material
                }
                if (child.name) {
                  // child.layers.set(1)
                  app.mesh[child.name] = child
                }
              }
              // console.log('child', child)
            })

            app.mat.Ground.roughness = 0.62
            app.mat.Ground.metalness = 0.14
            app.mat.Ground.color.r = 0.37
            app.mat.Ground.color.g = 0.37
            app.mat.Ground.color.b = 0.37
            app.mat.Ground.emissive.r = 0
            app.mat.Ground.emissive.g = 0
            app.mat.Ground.emissive.b = 0
            app.mat.Ground.emissiveIntensity = 1
            app.mat.Ground.opacity = 1
            app.mat.Skydome.roughness = 1
            app.mat.Skydome.metalness = 0
            app.mat.Skydome.color.r = 1
            app.mat.Skydome.color.g = 1
            app.mat.Skydome.color.b = 1
            app.mat.Skydome.emissive.r = 0.47
            app.mat.Skydome.emissive.g = 0.47
            app.mat.Skydome.emissive.b = 0.47
            app.mat.Skydome.emissiveIntensity = 1
            app.mat.Skydome.opacity = 1
            app.mat.Chromes_Exterior.roughness = 0.1
            app.mat.Chromes_Exterior.metalness = 1
            app.mat.Chromes_Exterior.color.r = 0.53
            app.mat.Chromes_Exterior.color.g = 0.53
            app.mat.Chromes_Exterior.color.b = 0.53
            app.mat.Chromes_Exterior.emissive.r = 0
            app.mat.Chromes_Exterior.emissive.g = 0
            app.mat.Chromes_Exterior.emissive.b = 0
            app.mat.Chromes_Exterior.emissiveIntensity = 1
            app.mat.Chromes_Exterior.opacity = 1
            app.mat.Exterior_Plastic_2.roughness = 0.15
            app.mat.Exterior_Plastic_2.metalness = 0.57
            app.mat.Exterior_Plastic_2.color.r = 0
            app.mat.Exterior_Plastic_2.color.g = 0
            app.mat.Exterior_Plastic_2.color.b = 0
            app.mat.Exterior_Plastic_2.emissive.r = 0
            app.mat.Exterior_Plastic_2.emissive.g = 0
            app.mat.Exterior_Plastic_2.emissive.b = 0
            app.mat.Exterior_Plastic_2.emissiveIntensity = 1
            app.mat.Exterior_Plastic_2.opacity = 1
            app.mat.Exterior_Plastic.roughness = 0.08
            app.mat.Exterior_Plastic.metalness = 0.99
            app.mat.Exterior_Plastic.color.r = 0.07999999999999996
            app.mat.Exterior_Plastic.color.g = 0.07999999999999996
            app.mat.Exterior_Plastic.color.b = 0.07999999999999996
            app.mat.Exterior_Plastic.emissive.r = 0
            app.mat.Exterior_Plastic.emissive.g = 0
            app.mat.Exterior_Plastic.emissive.b = 0
            app.mat.Exterior_Plastic.emissiveIntensity = 1
            app.mat.Exterior_Plastic.opacity = 1
            app.mat.EQC_Blue_Details.roughness = 1
            app.mat.EQC_Blue_Details.metalness = 0
            app.mat.EQC_Blue_Details.color.r = 0.047058823529411764
            app.mat.EQC_Blue_Details.color.g = 0.3764705882352941
            app.mat.EQC_Blue_Details.color.b = 0.9098039215686274
            app.mat.EQC_Blue_Details.emissive.r = 0
            app.mat.EQC_Blue_Details.emissive.g = 0
            app.mat.EQC_Blue_Details.emissive.b = 0
            app.mat.EQC_Blue_Details.emissiveIntensity = 1
            app.mat.EQC_Blue_Details.opacity = 1
            app.mat.Exterior_Plastic_Fresnel.roughness = 0.47000000000000003
            app.mat.Exterior_Plastic_Fresnel.metalness = 0.73
            app.mat.Exterior_Plastic_Fresnel.color.r = 0.02000000000000002
            app.mat.Exterior_Plastic_Fresnel.color.g = 0.02000000000000002
            app.mat.Exterior_Plastic_Fresnel.color.b = 0.02000000000000002
            app.mat.Exterior_Plastic_Fresnel.emissive.r = 0
            app.mat.Exterior_Plastic_Fresnel.emissive.g = 0
            app.mat.Exterior_Plastic_Fresnel.emissive.b = 0
            app.mat.Exterior_Plastic_Fresnel.emissiveIntensity = 1
            app.mat.Exterior_Plastic_Fresnel.opacity = 1
            app.mat['Tire 1'].roughness = 0.84
            app.mat['Tire 1'].metalness = 0.97
            app.mat['Tire 1'].color.r = 0.08999999999999997
            app.mat['Tire 1'].color.g = 0.08999999999999997
            app.mat['Tire 1'].color.b = 0.08999999999999997
            app.mat['Tire 1'].emissive.r = 0
            app.mat['Tire 1'].emissive.g = 0
            app.mat['Tire 1'].emissive.b = 0
            app.mat['Tire 1'].emissiveIntensity = 0
            app.mat['Tire 1'].opacity = 1
            app.mat.Mask_Exterior.roughness = 0.63
            app.mat.Mask_Exterior.metalness = 0.47
            app.mat.Mask_Exterior.color.r = 0.050980392156862744
            app.mat.Mask_Exterior.color.g = 0.050980392156862744
            app.mat.Mask_Exterior.color.b = 0.050980392156862744
            app.mat.Mask_Exterior.emissive.r = 0
            app.mat.Mask_Exterior.emissive.g = 0
            app.mat.Mask_Exterior.emissive.b = 0
            app.mat.Mask_Exterior.emissiveIntensity = 1
            app.mat.Mask_Exterior.opacity = 1
            app.mat.CarPaint_Silver.roughness = 0.15
            app.mat.CarPaint_Silver.metalness = 0.99
            app.mat.CarPaint_Silver.color.r = 1
            app.mat.CarPaint_Silver.color.g = 1
            app.mat.CarPaint_Silver.color.b = 1
            app.mat.CarPaint_Silver.emissive.r = 0
            app.mat.CarPaint_Silver.emissive.g = 0
            app.mat.CarPaint_Silver.emissive.b = 0
            app.mat.CarPaint_Silver.emissiveIntensity = 1
            app.mat.CarPaint_Silver.opacity = 1
            app.mat.CarPaint_Silver.aoMapIntensity = 0.7
            app.mat.Rear_Lights_Main.roughness = 1
            app.mat.Rear_Lights_Main.metalness = 0
            app.mat.Rear_Lights_Main.color.r = 0.8
            app.mat.Rear_Lights_Main.color.g = 0.8
            app.mat.Rear_Lights_Main.color.b = 0.8
            app.mat.Rear_Lights_Main.emissive.r = 1
            app.mat.Rear_Lights_Main.emissive.g = 1
            app.mat.Rear_Lights_Main.emissive.b = 1
            app.mat.Rear_Lights_Main.emissiveIntensity = 1
            app.mat.Rear_Lights_Main.opacity = 1
            app.mat.Rear_Lights_Cover.roughness = 0
            app.mat.Rear_Lights_Cover.metalness = 1
            app.mat.Rear_Lights_Cover.color.r = 0.28
            app.mat.Rear_Lights_Cover.color.g = 0
            app.mat.Rear_Lights_Cover.color.b = 0
            app.mat.Rear_Lights_Cover.emissive.r = 0
            app.mat.Rear_Lights_Cover.emissive.g = 0
            app.mat.Rear_Lights_Cover.emissive.b = 0
            app.mat.Rear_Lights_Cover.emissiveIntensity = 1
            app.mat.Rear_Lights_Cover.opacity = 0.71
            app.mat.MainWindows.roughness = 0
            app.mat.MainWindows.metalness = 1
            app.mat.MainWindows.color.r = 0
            app.mat.MainWindows.color.g = 0
            app.mat.MainWindows.color.b = 0
            app.mat.MainWindows.emissive.r = 0
            app.mat.MainWindows.emissive.g = 0
            app.mat.MainWindows.emissive.b = 0
            app.mat.MainWindows.emissiveIntensity = 1
            app.mat.MainWindows.opacity = 0.67
            app.mat.Light_Cover.roughness = 0
            app.mat.Light_Cover.metalness = 1
            app.mat.Light_Cover.color.r = 0.5411764705882353
            app.mat.Light_Cover.color.g = 0.5411764705882353
            app.mat.Light_Cover.color.b = 0.5411764705882353
            app.mat.Light_Cover.emissive.r = 0
            app.mat.Light_Cover.emissive.g = 0
            app.mat.Light_Cover.emissive.b = 0
            app.mat.Light_Cover.emissiveIntensity = 1
            app.mat.Light_Cover.opacity = 0.43
            app.mat.Mirrors.roughness = 1
            app.mat.Mirrors.metalness = 0
            app.mat.Mirrors.color.r = 0.8
            app.mat.Mirrors.color.g = 0.8
            app.mat.Mirrors.color.b = 0.8
            app.mat.Mirrors.emissive.r = 0
            app.mat.Mirrors.emissive.g = 0
            app.mat.Mirrors.emissive.b = 0
            app.mat.Mirrors.emissiveIntensity = 1
            app.mat.Mirrors.opacity = 1
            app.mat.Chrome_Blue_Front_Lights.roughness = 1
            app.mat.Chrome_Blue_Front_Lights.metalness = 0
            app.mat.Chrome_Blue_Front_Lights.color.r = 0.8
            app.mat.Chrome_Blue_Front_Lights.color.g = 0.8
            app.mat.Chrome_Blue_Front_Lights.color.b = 0.8
            app.mat.Chrome_Blue_Front_Lights.emissive.r = 0
            app.mat.Chrome_Blue_Front_Lights.emissive.g = 0
            app.mat.Chrome_Blue_Front_Lights.emissive.b = 0
            app.mat.Chrome_Blue_Front_Lights.emissiveIntensity = 1
            app.mat.Chrome_Blue_Front_Lights.opacity = 1
            app.mat.Front_Lights.roughness = 1
            app.mat.Front_Lights.metalness = 0
            app.mat.Front_Lights.color.r = 0.96
            app.mat.Front_Lights.color.g = 0.96
            app.mat.Front_Lights.color.b = 0.96
            app.mat.Front_Lights.emissive.r = 1
            app.mat.Front_Lights.emissive.g = 1
            app.mat.Front_Lights.emissive.b = 1
            app.mat.Front_Lights.emissiveIntensity = 1
            app.mat.Front_Lights.opacity = 1
            app.mat.Rear_Lights_Reflector.roughness = 1
            app.mat.Rear_Lights_Reflector.metalness = 0
            app.mat.Rear_Lights_Reflector.color.r = 0.8
            app.mat.Rear_Lights_Reflector.color.g = 0.8
            app.mat.Rear_Lights_Reflector.color.b = 0.8
            app.mat.Rear_Lights_Reflector.emissive.r = 0
            app.mat.Rear_Lights_Reflector.emissive.g = 0
            app.mat.Rear_Lights_Reflector.emissive.b = 0
            app.mat.Rear_Lights_Reflector.emissiveIntensity = 1
            app.mat.Rear_Lights_Reflector.opacity = 1
            app.mat.Read_Lights_Cover_Detail.roughness = 0
            app.mat.Read_Lights_Cover_Detail.metalness = 1
            app.mat.Read_Lights_Cover_Detail.color.r = 0.28
            app.mat.Read_Lights_Cover_Detail.color.g = 0.06887993164062499
            app.mat.Read_Lights_Cover_Detail.color.b = 0.06887993164062499
            app.mat.Read_Lights_Cover_Detail.emissive.r = 0
            app.mat.Read_Lights_Cover_Detail.emissive.g = 0
            app.mat.Read_Lights_Cover_Detail.emissive.b = 0
            app.mat.Read_Lights_Cover_Detail.emissiveIntensity = 0
            app.mat.Read_Lights_Cover_Detail.opacity = 0.66
            app.mat['Exterior_Plastic 1'].roughness = 0.25
            app.mat['Exterior_Plastic 1'].metalness = 0.72
            app.mat['Exterior_Plastic 1'].color.r = 0.08999999999999997
            app.mat['Exterior_Plastic 1'].color.g = 0.08999999999999997
            app.mat['Exterior_Plastic 1'].color.b = 0.08999999999999997
            app.mat['Exterior_Plastic 1'].emissive.r = 0
            app.mat['Exterior_Plastic 1'].emissive.g = 0
            app.mat['Exterior_Plastic 1'].emissive.b = 0
            app.mat['Exterior_Plastic 1'].emissiveIntensity = 1
            app.mat['Exterior_Plastic 1'].opacity = 1
            app.mat.Chromes_Light_Exterior.roughness = 1
            app.mat.Chromes_Light_Exterior.metalness = 0.49
            app.mat.Chromes_Light_Exterior.color.r = 0.35
            app.mat.Chromes_Light_Exterior.color.g = 0.35
            app.mat.Chromes_Light_Exterior.color.b = 0.35
            app.mat.Chromes_Light_Exterior.emissive.r = 0
            app.mat.Chromes_Light_Exterior.emissive.g = 0
            app.mat.Chromes_Light_Exterior.emissive.b = 0
            app.mat.Chromes_Light_Exterior.emissiveIntensity = 1
            app.mat.Chromes_Light_Exterior.opacity = 1
            app.mat.Plates.roughness = 0.97
            app.mat.Plates.metalness = 0.46
            app.mat.Plates.color.r = 0.54
            app.mat.Plates.color.g = 0.54
            app.mat.Plates.color.b = 0.54
            app.mat.Plates.emissive.r = 0
            app.mat.Plates.emissive.g = 0
            app.mat.Plates.emissive.b = 0
            app.mat.Plates.emissiveIntensity = 1
            app.mat.Plates.opacity = 1
            app.mat.Interior_Plastic.roughness = 0.81
            app.mat.Interior_Plastic.metalness = 1
            app.mat.Interior_Plastic.color.r = 0.10196078431372549
            app.mat.Interior_Plastic.color.g = 0.10196078431372549
            app.mat.Interior_Plastic.color.b = 0.10196078431372549
            app.mat.Interior_Plastic.emissive.r = 0
            app.mat.Interior_Plastic.emissive.g = 0
            app.mat.Interior_Plastic.emissive.b = 0
            app.mat.Interior_Plastic.emissiveIntensity = 1
            app.mat.Interior_Plastic.opacity = 1
            app.mat.CarShadow.roughness = 1
            app.mat.CarShadow.metalness = 0.43
            app.mat.CarShadow.color.r = 0
            app.mat.CarShadow.color.g = 0
            app.mat.CarShadow.color.b = 0
            app.mat.CarShadow.emissive.r = 0
            app.mat.CarShadow.emissive.g = 0
            app.mat.CarShadow.emissive.b = 0
            app.mat.CarShadow.emissiveIntensity = 1
            app.mat.CarShadow.opacity = 0.93
            app.gltf = code.scene
            app.gltf.scale.setScalar(50)
            app.gltf.rotation.y = 2.5

            // let lights = [
            //   'Front_Lights_0',
            //   'Front_Lights_1',
            //   'Front_Lights_2',
            //   'Front_Lights_3'
            // ]
            // app.glowMeshes = {}
            // for (let i = 0; i < lights.length; i++) {
            //   let k = lights[i]
            //   if (k in app.mesh) {
            //     app.glowMeshes[k] = app.mesh[k].clone()
            //     app.glowMeshes[k].material = app.glow.clone()
            //     app.glowMeshes[k].material.uniforms.glowColor.value = new THREE.Color(0xFFFFFF)
            //     app.glowMeshes[k].scale.setScalar(1)
            //     app.mesh[k].parent.add(app.glowMeshes[k])
            //   }
            // }

            app.sceneForeground.add(app.gltf)
            app.datGui()
            setTimeout(() => {
              app.resize()
              app.preloadComplete()
            }, 1000)
          }, (xhr) => {
            console.log(xhr.loaded / 1024, 'KB model loaded')
          }, (err) => {
            console.log(err)
          })
        })
      },
      initCamera: () => {
        app.camera = new THREE.PerspectiveCamera(app.params.camera.fov, app.aspectRatio, app.params.camera.near, app.params.camera.far)
        app.camera.position.set(new THREE.Vector3(app.params.camera.baseX, app.params.camera.baseY, app.params.camera.baseZ))
        // app.camera.layers.enable(1)
        app.scene.add(app.camera)
        app.resetCamera()
      },
      initLights: () => {
        app.light.scene = new THREE.AmbientLight(new THREE.Color(app.rgbIn(app.params.ambientColor.r), app.rgbIn(app.params.ambientColor.g), app.rgbIn(app.params.ambientColor.b)), 0.1)
        app.scene.add(app.light.scene)
        app.light.ambient = new THREE.DirectionalLight(new THREE.Color(app.rgbIn(app.params.ambientColor.r), app.rgbIn(app.params.ambientColor.g), app.rgbIn(app.params.ambientColor.b)), 1)
        app.light.ambient.position.set(200, 100, 0)
        app.light.ambient.lookAt(new THREE.Vector3(0, 0, 0))
        app.light.ambient.castShadow = true
        app.light.ambient.shadow.mapSize.width = 2048
        app.light.ambient.shadow.mapSize.height = 2048
        app.scene.add(app.light.ambient)
      },
      resetCamera: () => {
        app.updateCamera()
      },
      updateCamera: () => {
        app.camera.aspect = app.aspectRatio
        app.camera.lookAt(app.cameraTarget)
        app.camera.updateProjectionMatrix()
      },
      fitCameraToObject: () => {
        let offset = 1.25
        const boundingBox = new THREE.Box3()
        boundingBox.setFromObject(app.cameraGroup)
        const center = boundingBox.getCenter()
        const size = boundingBox.getSize()

        // get the max side of the bounding box (fits to width OR height as needed )
        const maxDim = Math.max(size.x, size.y, size.z)
        const fov = app.camera.fov * (Math.PI / 180)
        let cameraZ = Math.abs(maxDim / 2 * Math.tan(fov * 2)) // Applied fifonik correction

        cameraZ *= offset // zoom out a little so that objects don't fill the screen

        // <--- NEW CODE
        // Method 1 to get object's world position
        app.scene.updateMatrixWorld() // Update world positions
        var objectWorldPosition = new THREE.Vector3()
        objectWorldPosition.setFromMatrixPosition(app.cameraGroup.matrixWorld)

        // Method 2 to get object's world position
        // objectWorldPosition = object.getWorldPosition();

        const directionVector = app.camera.position.sub(objectWorldPosition) // Get vector from camera to object
        const unitDirectionVector = directionVector.normalize() // Convert to unit vector
        app.camera.position = unitDirectionVector.multiplyScalar(cameraZ) // Multiply unit vector times cameraZ distance
        // camera.lookAt(objectWorldPosition) // Look at object
        // --->

        const minZ = boundingBox.min.z
        const cameraToFarEdge = (minZ < 0) ? -minZ + cameraZ : cameraZ - minZ

        app.camera.far = cameraToFarEdge * 3
        app.camera.updateProjectionMatrix()

        if (app.controls) {
          app.controls.target = center
          // prevent camera from zooming out far enough to create far plane cutoff
          app.controls.maxDistance = cameraToFarEdge * 2
          app.controls.saveState()
        } else {
          app.camera.lookAt(center)
        }
      },
      initMenu: () => {
        dom.menu.css({ display: 'block' })
        app.params.menu.circleDashoffset = anime.setDashoffset(dom.menuSvgProgress.get(0))
        dom.menuSvgProgress.attr({
          'stroke-dasharray': app.params.menu.circleDashoffset,
          'stroke-dashoffset': app.params.menu.circleDashoffset,
          'opacity': 1
        })
        dom.menuSvgProgressBg.attr({
          'stroke-dasharray': app.params.menu.circleDashoffset,
          'stroke-dashoffset': app.params.menu.circleDashoffset,
          'opacity': 0
        })
        dom.menuSvgHover.attr({
          'stroke-dasharray': app.params.menu.circleDashoffset,
          'stroke-dashoffset': app.params.menu.circleDashoffset,
          'opacity': 0
        })
        app.timelines.menuPulsate = {
          played: 0,
          max: 2,
          play: () => {
            app.timelines.menuPulsate.played++
            TweenLite.to(dom.menuSvgPulsate.eq(0), 0.3, {
              opacity: 0.7,
              ease: Power2.easeOut,
              onComplete: () => {
                TweenLite.to(dom.menuSvgPulsate.eq(0), 0.3, {
                  opacity: 0,
                  ease: Power2.easeIn
                })
              }
            })
            TweenLite.to(dom.menuSvgPulsate.eq(1), 0.3, {
              delay: 0.2,
              opacity: 0.7,
              ease: Power2.easeOut,
              onComplete: () => {
                TweenLite.to(dom.menuSvgPulsate.eq(1), 0.3, {
                  opacity: 0,
                  ease: Power2.easeIn,
                  onComplete: () => {
                    if (app.timelines.menuPulsate.played < app.timelines.menuPulsate.max) {
                      setTimeout(app.timelines.menuPulsate.play, 400)
                    }
                  }
                })
              }
            })
          },
          restart: () => {
            app.timelines.menuPulsate.played = 0
            app.timelines.menuPulsate.play()
          },
          open: () => {
            app.timelines.menuPulsate.played = 1
            app.timelines.menuPulsate.play()
          }
        }

        dom.menuUl = dom.menu.find('ul')
        dom.menuLi = dom.menuUl.find('li')
        dom.menu.find('.eqc-3d--menu-overlay').on('click', (e) => {
          app.menuClose()
        })
        dom.menuButton.on('click', (e) => {
          e.preventDefault()
          if (app.params.menu.open) {
            app.menuClose()
          } else {
            app.menuOpen()
          }
        }).on('mouseenter', (e) => {
          if (!isMobile.any) {
            TweenLite.to(dom.menuSvgHover, 0.4, {
              strokeDashoffset: 0,
              ease: Power2.easeInOutCubic
            })
          }
        }).on('mouseleave', (e) => {
          if (!isMobile.any) {
            TweenLite.to(dom.menuSvgHover, 0.4, {
              strokeDashoffset: app.params.menu.circleDashoffset,
              ease: Power2.easeOutCubic
            })
          }
        })
      },
      menuOpen: () => {
        if (isMobile.any) {
          TweenLite.to(dom.menuSvgHover, 0.4, {
            strokeDashoffset: 0,
            ease: Power2.easeInOutCubic
          })
        }
        app.timelines.menuPulsate.open()
        app.params.menu.open = true
        dom.body.addClass('blur')
        dom.menu.removeClass('close open')
        dom.menu.addClass('view')
        setTimeout(() => {
          if (app.params.menu.open) {
            dom.menuLi.eq(2).children('a').addClass('active')
            dom.menu.addClass('open')
          }
        }, dom.menuLi.length * 50 + 600)
      },
      menuClose: () => {
        if (isMobile.any) {
          TweenLite.to(dom.menuSvgHover, 0.4, {
            strokeDashoffset: app.params.menu.circleDashoffset,
            ease: Power2.easeOutCubic
          })
        }
        app.params.menu.open = false
        dom.body.removeClass('blur')
        dom.menu.addClass('close')
        setTimeout(() => {
          if (!app.params.menu.open) {
            dom.menu.removeClass('view')
            setTimeout(() => {
              if (!app.params.menu.open) {
                dom.menu.removeClass('open')
                dom.menu.removeClass('close')
              }
            }, 50 * dom.menuLi.length + 300)
          }
        }, 200)
      },
      postprocessing: () => {
        let VignetteShader = {
          uniforms: {
            'tDiffuse': {type: 't', value: null},
            'offset': {type: 'f', value: 1.0},
            'darkness': {type: 'f', value: 1.0}
          },
          vertexShader: [
            'varying vec2 vUv;',
            'void main() {',
            'vUv = uv;',
            'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
            '}'
          ].join('\n'),
          fragmentShader: [
            'uniform float offset;',
            'uniform float darkness;',
            'uniform sampler2D tDiffuse;',
            'varying vec2 vUv;',
            'void main() {',
            // Eskil's vignette
            'vec4 texel = texture2D( tDiffuse, vUv );',
            'vec2 uv = ( vUv - vec2( 0.5 ) ) * vec2( offset );',
            'gl_FragColor = vec4( mix( texel.rgb, vec3( 1.0 - darkness ), dot( uv, uv ) ), texel.a );',
            /*
            // alternative version from glfx.js
            // this one makes more 'dusty' look (as opposed to 'burned')
            'vec4 color = texture2D( tDiffuse, vUv );',
            'float dist = distance( vUv, vec2( 0.5 ) );',
            'color.rgb *= smoothstep( 0.8, offset * 0.799, dist *( darkness + offset ) );',
            'gl_FragColor = color;',
            */
            '}'
          ].join('\n')
        }
        app.renderPass = new THREE.RenderPass(app.scene, app.camera)
        app.pass = {
          fxaa: new THREE.ShaderPass(THREE.FXAA),
          bloom: new THREE.BloomPass(new THREE.Vector2(app.params.page.winWidth * app.renderer.getPixelRatio(), app.params.page.winHeight * app.renderer.getPixelRatio()), 0.7, 0.31, 0.38),
          copy: new THREE.ShaderPass(THREE.CopyShader),
          ssaa: new THREE.SSAARenderPass(app.scene, app.camera),
          bokeh: new THREE.BokehPass(app.scene, app.camera, {
            focus: 1.0,
            aperture: 0.025,
            maxblur: 1.0,
            width: app.params.page.winWidth,
            height: app.params.page.winHeight
          }),
          vignette: new THREE.ShaderPass(VignetteShader)
        }
        app.pass.fxaa.uniforms['resolution'].value.set(1 / app.params.page.winWidth, 1 / app.params.page.winHeight)
        app.pass.ssaa.unbiased = true
        app.pass.ssaa.sampleLevel = 2
        app.pass.vignette.renderToScreen = true
        app.pass.vignette.uniforms.darkness.value = 1.2
        // app.pass.bokeh.renderToScreen = true
        app.composer = new THREE.EffectComposer(app.renderer)
        app.composer.setSize(app.params.page.winWidth * 2, app.params.page.winHeight * 2)
        app.composer.addPass(app.renderPass)
        // app.composer.addPass(app.pass.fxaa)
        // app.composer.addPass(app.pass.bokeh)
        // app.composer.addPass(app.pass.ssaa)
        // app.composer.addPass(app.pass.bloom)
        app.composer.addPass(app.pass.vignette)
      },
      render: () => {
        requestAnimationFrame(app.render)
        app.scrollPos()
        if (app.params.page.topRange || app.params.page.topRangeClose || app.params.page.bottomRange || app.params.page.bottomRangeClose) {
          // if (!app.renderer.autoClear) app.renderer.clear()
          // move camera position depending on mousemove and scroll position
          if (!app.controls.enabled) {
            app.camera.position.x = app.params.camera.baseX - (app.params.camera.move.maxX / 100 * app.params.camera.move.offsetX)
            app.camera.position.y = (app.params.camera.baseY - ((app.params.camera.baseY / 100 * app.params.camera.scroll.offsetY) + (app.params.camera.move.maxY / 100 * app.params.camera.move.offsetY))) + app.params.camera.minY
            app.camera.position.y = app.camera.position.y < app.params.camera.minY ? app.params.camera.minY : app.camera.position.y
            app.camera.position.z = app.params.camera.baseZ - (Math.abs(app.params.camera.move.maxY / 100 * app.params.camera.move.offsetY) / 5) - (Math.abs(app.params.camera.move.maxX / 100 * app.params.camera.move.offsetX) / 5)
            app.cameraTarget.y = app.params.camera.lookAtTarget ? app.params.camera.lookY : (app.camera.position.y - (app.params.camera.baseY * app.params.camera.scroll.angleY / 100)) - app.params.camera.minY
            app.updateCamera()
          } else {
            app.updateCamera()
            app.controls.update()
          }
          // console.log(app.cameraTarget.y)
          app.renderer.clear()
          if (app.params.usePostProcessing) {
            // app.camera.layers.set(1)
            app.composer.render()
          } else {
            app.renderer.render(app.scene, app.camera)
          }
        }
      }
    }

    app.init()

    window.eqc = app
    window.eqcDom = dom
  })
})



// WEBPACK FOOTER //
// ./src/components/eqc/eqc-3d.js